import React, { useState } from 'react';
import { OfferSearchFilters, OfferSearchFormProps } from '../../Types/offerTypes';
import { useGetOffersFilterSelectsQuery } from '../../Service/extendedOffersApi';
import SearchFormWrapper from '../../../Shared/Components/SearchFormWrapper';
import { fieldsSearch } from './fieldsSearch';
import { searchFormInitialValues } from './initialValus';
import { IdNameDto } from '../../../Shared/Types/common';
import { useFieldsWithFilterOptions } from '../../../Shared/Hooks/useFieldsWithOptions';


const OfferSearchForm = ({ onSearch }: OfferSearchFormProps) => {
  const [filters, setFilters] = useState<OfferSearchFilters>(searchFormInitialValues);
  const { data: filterData } = useGetOffersFilterSelectsQuery();
  const fieldToFilterKey = {
    categoryId: 'categories',
    hotelId: 'hotels',
    countryId: 'countries',
    regionId: 'regions',
    companyId: 'companies',
    published: 'publishedOptions',
  };
  const fields = useFieldsWithFilterOptions(
    fieldsSearch,
    (filterData as unknown as Record<string, IdNameDto[]>) ?? {},
    fieldToFilterKey
  ) as unknown as typeof fieldsSearch;

  const handleSearch = (values: Record<string, string>) => {
    setFilters(values as unknown as OfferSearchFilters);
    onSearch({
      searchTerm: values.searchTerm?.trim() || '',
      categoryId: values.categoryId ? parseInt(values.categoryId).toString() : '',
      hotelId: values.hotelId ? parseInt(values.hotelId).toString() : '',
      countryId: values.countryId ? parseInt(values.countryId).toString() : '',
      regionId: values.regionId ? parseInt(values.regionId).toString() : '',
      companyId: values.companyId ? parseInt(values.companyId).toString() : '',
      published: values.published === '' ? '' : values.published === 'true' ? 'true' : 'false',
    });
  };

  const handleReset = () => {
    setFilters(searchFormInitialValues);
    onSearch(searchFormInitialValues);
  };

  return (
    <SearchFormWrapper
      fields={fields}
      initialValues={filters as unknown as Record<string, string>}
      onSubmit={handleSearch}
      onReset={handleReset}
      resetValues={searchFormInitialValues as unknown as Record<string, string>}
      showResetButton
    />
  );
};

export default OfferSearchForm;
